import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {ShippingProvidersActions} from '../store';
import {ShippingProvidersToDataRecoverySelectors} from '../store/selectors';

@Injectable()
export class ShippingProvidersToDataRecoveryLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadShippingProvidersDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadShippingProvidersDone() {

    return this.store.pipe(
      select(ShippingProvidersToDataRecoverySelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(ShippingProvidersActions.ReadShippingProvidersToDataRecovery());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
